import { Profissional } from './profissional.model';
import { ComposicaoEquipe } from './composicao-equipe.model';

export class Equipe {
    id: number;
    estimativaId: number;
    profissionalId: number;
    nome: string;
    clt: boolean;
    cooperado: boolean;
    baseHora?: number;
    valorSalarioHora?: number;
    piCota?: number;
    vr?: number;
    ajudaCusto?: number;
    beneficio?: number;
    custoHora?: number;
    precoHora?: number;
    margemLiquida?: number;
    receitaBruta?: number;
    profissional: Profissional = new Profissional();
    composicaoEquipe: ComposicaoEquipe = new ComposicaoEquipe();
    dtInclusao: Date;
    [key: string]: any;
}
